import axios from '@/plugins/axios/index.js'
import { handleAsync } from 'best-modules/plugins'
import { generateId } from '@/utils/helpers.js'
import { toPath, keepArray } from 'best-modules/utils'
import { urlUploadFiles, urlClientAccessUploadFile } from '@/utils/urls.js'
import { File } from '@/utils/types/helpers'

export type MainFolder =
  | 'document'
  | 'Документы'
  | 'Корреспонденция'
  | 'Приказы'
  | 'Пользователи'
  | 'Задачи'
  | 'Протоколи'
  | 'Аудит'
  | 'План'
  | 'Операційні ризики'
export type NameFolder = 'Документ' | 'фото' | 'template' | string
export interface UploadFilesOptions {
  files?: Blob | Blob[]
  mainFolder: MainFolder
  nameFolder: NameFolder
  prefixFolder?: string
  Authorization?: string
  isClient?: boolean
}
export function uploadFiles({
  files,
  nameFolder,
  mainFolder,
  prefixFolder,
  Authorization,
  isClient,
}: UploadFilesOptions): Promise<{
  paths: string[]
  files: File[]
}> {
  if (keepArray(files).length === 0) {
    return Promise.reject({ files: [], paths: [] })
  }

  const formData = new FormData()

  formData.append('mainFolder', mainFolder)
  formData.append('nameFolder', nameFolder)
  prefixFolder && formData.append('prefixFolder', prefixFolder)

  for (const file of keepArray(files)) {
    formData.append('file[]', file as Blob)
  }

  const url = isClient ? urlClientAccessUploadFile : urlUploadFiles

  return handleAsync(`uploadFile_${mainFolder}_${nameFolder}`, () => {
    return axios
      .post(url(), formData, {
        headers: { Authorization },
      })
      .then(res => {
        // formatting path to path with "/" in start
        const pathList = res.data.files.map((p: any) => toPath(p))
        // formatting paths to Objects of files
        const fileList = pathList.map((p: any, i: any) => {
          return {
            id: generateId(),
            // @ts-ignore
            name: keepArray(files)[i]?.name,
            size: keepArray(files)[i]?.size,
            path: p,
          }
        })

        return { files: fileList, paths: pathList }
      })
  })
}
